export const LANGUAGE_CONFIG = {
  nl: { value: 'nl', label: 'Nederlands', shortLabel: 'NL' },
  en: { value: 'en', label: 'English', shortLabel: 'EN' },
} as const

export type SupportedLanguage = keyof typeof LANGUAGE_CONFIG
export type LanguageOption = (typeof LANGUAGE_CONFIG)[SupportedLanguage]

const REGION_CONFIG = {
  uk: ['en'],
  nl: ['nl', 'en'],
} as const satisfies Record<
  string,
  readonly [SupportedLanguage, ...SupportedLanguage[]]
>

export type Region = keyof typeof REGION_CONFIG

const DEFAULT_REGION: Region = 'nl'

export function resolveRegion(value: unknown): Region {
  if (typeof value === 'string' && value in REGION_CONFIG) {
    return value as Region
  }

  if (value) {
    console.warn(
      `Invalid TMC_REGION "${String(value)}"; defaulting to "${DEFAULT_REGION}"`
    )
  }

  return DEFAULT_REGION
}

// Guarded: the SPA prerender evaluates this module in Node, where window does not exist.
export const region = resolveRegion(
  typeof window !== 'undefined' ? window._env_?.TMC_REGION : undefined
)
export const supportedLanguages = REGION_CONFIG[region]

export const languageOptions: LanguageOption[] = supportedLanguages.map(
  language => LANGUAGE_CONFIG[language]
)

export const defaultLanguage: SupportedLanguage = supportedLanguages[0]
export const canSelectLanguage = supportedLanguages.length > 1

export function resolveLanguage(language: string | null): SupportedLanguage {
  return supportedLanguages.find(
    supportedLanguage => supportedLanguage === language
  ) ?? defaultLanguage
}
